export const normalizeIp = (v: string) => (v || '').trim();

export const isValidIpv4 = (ip: string) => {
  const parts = ip.split('.');
  if (parts.length !== 4) return false;
  for (const p of parts) {
    if (!/^\d+$/.test(p)) return false;
    const n = Number(p);
    if (n < 0 || n > 255) return false;
    if (p.length > 1 && p.startsWith('0')) return false;
  }
  return true;
};

export const validateIpv4ForWhitelist = (ipRaw: string, existing: string[]) => {
  const ip = normalizeIp(ipRaw);
  if (!ip) return { ok: false, ip, error: 'IP is required' };
  if (!isValidIpv4(ip)) return { ok: false, ip, error: 'Invalid IPv4 address' };
  if (existing.includes(ip)) return { ok: false, ip, error: 'This IP already exists' };
  return { ok: true, ip, error: '' };
};
